import { FormControl as MuiFormControl } from '@mui/material';
import { styled } from '../muiReexports';
export const FormControlStyled = styled(MuiFormControl, {
    shouldForwardProp: (prop) => prop !== 'fullWidthFlex',
})(({ fullWidthFlex }) => ({
    ...(fullWidthFlex && { flex: 1, width: 'unset' }),
}));
